import { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import PaginationBox from "../../../Components/Masters/Pagination";
import ColumnHeadings from "../../../Components/Masters/ColumnHeadings";
import MenuActions from "./MenuActions";
import TableContent from "../../../Components/Masters/TableContent";
import TableHeading from "../../../Components/Masters/TableHeading";
import MenuIcon from "../../../Components/Masters/MenuIcon";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import { useNavigate } from "react-router-dom";

const SentRequest = ({
  data = [],
  columnHeadings = [],
  user,
  /* pagination & sorting info from parent */
  page,
  totalPages,
  rowsPerPage,
  sortConfig,
  /* event callbacks to parent */
  onSort,
  onPageChange,
  /* misc callbacks */
  handleMenuClick1,
  isShortContent,
  bulkUploadCallback,
  handleSort,
}) => {
  const [sortConfig1, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const tableContainerRef = useRef(null); // Reference to the table container
  // const [isShortContent1, setIsShortContent] = useState(false);

  // useEffect(() => {
  //   const container = tableContainerRef.current;

  //   if (container) {
  //     const tableHeight = container.scrollHeight; // Get the table's height
  //     const screenHeight = window.innerHeight; // Get the viewport height

  //     setIsShortContent(tableHeight < screenHeight / 1.5);
  //   }
  // }, [data]);

  useEffect(() => {
    let arr = [
      {
        "S No.": "",
        "Month (in 01/25 or Jan-25)": "",
        "Value Chain Partner Name": "",
        "Natural Gas Emission (in tCO2e)": "",
        "Coal Emission (in tCO2e)": "",
        "Petrol Emission (in tCO2e)": "",
        "Diesel Emission (in tCO2e)": "",
        "Fuel Emission (in tCO2e)": "",
        "LPG Emission (in tCO2e)":  "",
        "Propane Emission (in tCO2e)": "",
        "OnRoad Emission (in tCO2e)": "",
        "OFRoad Emission (in tCO2e)": "",
        "Refrigeration Emission (in tCO2e)": "",
        "Extinguisher Emission (in tCO2e)": "",
        "Electricity Emission (in tCO2e)": "",
        "Heat Emission (in tCO2e)": "",
        "Steam Emission (in tCO2e)": "",
        "Purchase Goods (in tCO2e)": "",
        "Transportation Emission (in tCO2e)": "",
        "Employee Commute (in tCO2e)": "",
        "Waste Generated (in tCO2e)": "",
        "Business Travel (in tCO2e)": "",
      },
    ];

    setExcelData(arr);
  }, []);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
    bulkUploadCallback();
  };

  const handleEdit = () => {
    handleMenuClose();
    // setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    // setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  // Handle Sorting function
  // const handleSort = (column, direction) => {
  //   console.log("first1",column,direction)
  //   setSortConfig({ key: column, direction });
  // };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    handleMenuClose();
    bulkUploadCallback();
    // remove here
  };
  return (
    <>
      <Box
        sx={{
          // padding: "20px",
          backgroundColor: "#ededed",
          width: "100%",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "100%" }}
          ref={tableContainerRef}
        >
          <Box>
            <TableHeading heading={"Request Emission Data"} />
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: user?.companyAdmin
                  ? "12% 20% 17% 17% 15% 19% "
                  : "12% 17% 17% 17% 15% 14% 8%",
                borderBottom: "1px solid #ddd",
                borderTop: "1px solid #ddd",
              }}
            >
              {columnHeadings.map((el) => (
                <ColumnHeadings
                  key={el.fieldName}
                  {...{
                    title: el.title,
                    handleSort,
                    field: el.fieldName,
                    sortConfig,
                  }}
                />
              ))}
              {user?.companyAdmin ? null : (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              )}
            </Box>
            {data.length === 0 ? (
              <NoDataFound />
            ) : (
              data.map((item) => (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: user?.companyAdmin
                      ? "12% 20% 17% 17% 15% 19%"
                      : "12% 17% 17% 17% 15% 14% 8%",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  {columnHeadings.map((el) => {
                    const fieldData = item[el.fieldName];
                    let displayValue;

                    if (el.fieldName === "partnerCompany") {
                      displayValue =
                        fieldData?.companyName || item.newPartnerName;
                    } else if (el.fieldName === "facility") {
                      displayValue = item?.facility?.facilityName || "";
                    } else if (el.fieldName === "contactNumber" && fieldData) {
                      const countryCode = fieldData.countryCode?.startsWith("+")
                        ? fieldData.countryCode
                        : `+${fieldData.countryCode}`;
                      displayValue = `${countryCode} ${fieldData.mobileNo}`;
                    } else if (
                      typeof fieldData === "object" &&
                      fieldData !== null
                    ) {
                      displayValue = JSON.stringify(fieldData);
                    } else {
                      displayValue = fieldData;
                    }

                    return (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData: displayValue,
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    );
                  })}

                  {/* {!user?.companyAdmin &&
                    (item?.action !== "Accepted" ||
                      (item?.partner === "existing" &&
                        item?.action === "Pending")) && (
                      <MenuIcon
                        handleMenuClick={handleMenuClick}
                        field={item}
                      />
                    )} */}

                  {!user?.companyAdmin &&
                    (item?.partner === "new" ||
                      (item?.partner === "existing" &&
                        item?.action === "Rejected")) && (
                      <MenuIcon
                        handleMenuClick={handleMenuClick}
                        field={item}
                      />
                    )}
                </Box>
              ))
            )}
          </Box>
        </TableContainer>
        {/* Pagination */}
        {totalPages > 1 && (
          <PaginationBox
            isShortContent={isShortContent}
            // {...{
            //   totalPages,
            //   page,
            //   handleChangePage,
            //   StyledPaginationItem,
            // }}
            totalPages={totalPages}
            page={page}
            handleChangePage={onPageChange}
            rowsPerPage={rowsPerPage}
          />
        )}

        <MenuActions
          {...{
            id: element?._id,
            handleView,
            handleEdit,
            handleDelete,
            anchorEl,
            handleMenuClose,
            setBulkUploadModal,
            partnerType: selectedData?.partner,
            selectedData: selectedData,
          }}
        />
        {/*Add,Edit,Delete Icons & function calls */}
      </Box>
      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          setBulkUploadModal={setBulkUploadModal}
          fileName={"value chain partner"}
          url={"/valueChain/request/bulkupload"}
          setsnackOpen={setsnackOpen}
        />
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SentRequest;
